/**
 * Cкачивает файл. Поддерживает:
 * - Blob / File — скачивает бинарные данные.
 * - string — url для скачивания (например, оригинальная ссылка).
 * - object — объект с метаданными файла.
 */
type TFileMeta = {
    id: number;
    name: string;
    mimeType: string;
    previewUrl: string;
    previewSvgUrl: string;
    originalUrl: string;
};

const downloadFileByUrl = async (url: string, fileName = 'download') => {
    try {
        const res = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};

export const downloadFile = async (data: Blob | File | string | TFileMeta, fileName?: string) => {
    const saveBlob = (blob: Blob, fallbackName = 'download') => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName ?? (blob instanceof File ? blob.name : fallbackName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    };

    if (data instanceof Blob) {
        return saveBlob(data);
    }

    if (typeof data === 'string') {
        return downloadFileByUrl(data, fileName);
    }

    if (typeof data === 'object' && 'originalUrl' in data) {
        const url = data.originalUrl;
        const name = fileName ?? data.name ?? 'download';
        return downloadFileByUrl(url, name);
    }

    console.error('downloadFile: unsupported data type', data);
};
